export default class UserManagementEvents {
    public static gridRefreshEvent = "UserManagementRefresh";
}
